import {
  SET_IS_MOBILE,
  SET_THEME,
  SET_BACKEND_TIMEOUT
} from 'cityads-v3/actions/app';

import {
  GET_LAYOUT_DATA,
  GET_LAYOUT_DATA_SUCCESS,
  GET_LAYOUT_DATA_FAIL,
} from 'cityads-v3/actions/menu';

import {
  GET_NEWS,
  GET_NEWS_SUCCESS,
  GET_NEWS_FAIL,
  GET_NEWS_BY_ID,
  GET_NEWS_BY_ID_SUCCESS,
  GET_NEWS_BY_ID_FAIL,
} from 'cityads-v3/actions/news';

import {
  GET_OFFER_BY_ID,
  GET_OFFER_BY_ID_SUCCESS,
  GET_OFFER_BY_ID_FAIL,
} from 'cityads-v3/actions/offers';

import {
  GET_ZALEYCASH_ACCOUNTS,
  GET_ZALEYCASH_ACCOUNTS_SUCCESS,
  GET_ZALEYCASH_ACCOUNTS_FAIL,
} from 'cityads-v3/actions/zaleyCash';

export const initialState = {
  isMobile: false,
  queries: [],
};

export default function app(state = initialState, action = {}) {
  switch (action.type) {
    case SET_IS_MOBILE:
      return {
        ...state,
        isMobile: action.isMobile,
      };

    case SET_THEME:
      return {
        ...state,
        theme: action.theme
      }

    case GET_LAYOUT_DATA:
      return {
        ...state,
        queries: [
          ...state.queries,
          'GET_LAYOUT_DATA'
        ]
      };

    case GET_LAYOUT_DATA_SUCCESS:
    case GET_LAYOUT_DATA_FAIL:
      return {
        ...state,
        queries: state.queries.filter(item => item !== 'GET_LAYOUT_DATA')
      };

    case GET_NEWS:
      return {
        ...state,
        queries: [
          ...state.queries,
          'GET_NEWS'
        ]
      };

    case GET_NEWS_SUCCESS:
    case GET_NEWS_FAIL:
      return {
        ...state,
        queries: state.queries.filter(item => item !== 'GET_NEWS')
      };

    case GET_NEWS_BY_ID:
      return {
        ...state,
        queries: [
          ...state.queries,
          'GET_NEWS_BY_ID'
        ]
      };

    case GET_NEWS_BY_ID_SUCCESS:
    case GET_NEWS_BY_ID_FAIL:
      return {
        ...state,
        queries: state.queries.filter(item => item !== 'GET_NEWS_BY_ID')
      };

    case GET_OFFER_BY_ID:
      return {
        ...state,
        queries: [
          ...state.queries,
          'GET_OFFER_BY_ID'
        ]
      };

    case GET_OFFER_BY_ID_SUCCESS:
    case GET_OFFER_BY_ID_FAIL:
      return {
        ...state,
        queries: state.queries.filter(item => item !== 'GET_OFFER_BY_ID')
      };

    case GET_ZALEYCASH_ACCOUNTS:
      return {
        ...state,
        queries: [
          ...state.queries,
          'GET_ZALEYCASH_ACCOUNTS'
        ]
      };

    case GET_ZALEYCASH_ACCOUNTS_SUCCESS:
    case GET_ZALEYCASH_ACCOUNTS_FAIL:
      return {
        ...state,
        queries: state.queries.filter(item => item !== 'GET_ZALEYCASH_ACCOUNTS')
      };

    case SET_BACKEND_TIMEOUT:
      return {
        ...state,
        backendTimeout: true
      }

    default:
      return state;
  }
}
